import React from 'react';
import { motion } from 'framer-motion';
import { Shield, LayoutList, FileText } from 'lucide-react';
export function Benefits() {
  return <section className="py-10 sm:py-16 bg-white" data-id="element-13">
      <div className="container px-4 mx-auto max-w-5xl" data-id="element-14">
        <div className="text-center mb-8 sm:mb-12" data-id="element-15">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-black text-[#0c3b42] mb-3 sm:mb-4 uppercase tracking-tight" data-id="element-16">
            UN SISTEMA QUE TE ORDENA Y TE DA DIRECCIÓN EN DEPORTE ADAPTADO
          </h2>
          <div className="inline-block px-3 py-1.5 sm:px-4 sm:py-2 bg-[#e0f2fe] text-[#0c3b42] text-sm sm:text-base font-bold rounded-lg mb-4 sm:mb-6" data-id="element-17">
            KIT Psicología en Deporte Adaptado™ | Sistema Clínico Adaptado 8
            Etapas™
          </div>
          <p className="text-base sm:text-lg text-slate-600 max-w-3xl mx-auto leading-relaxed" data-id="element-18">
            Creamos un sistema claro y aplicable para que dejes de improvisar
            cuando trabajás con deportistas con discapacidad y empieces a
            intervenir con una estructura clínica adaptada desde la primera
            consulta hasta el cierre del proceso.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-4 sm:gap-8" data-id="element-19">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-slate-50 p-5 sm:p-8 rounded-2xl border border-slate-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-20">
            <div className="w-11 h-11 sm:w-14 sm:h-14 bg-[#0c3b42] rounded-xl flex items-center justify-center mb-4 sm:mb-6" data-id="element-21">
              <Shield className="w-6 h-6 sm:w-7 sm:h-7 text-[#7fd1c9]" data-id="element-22" />
            </div>
            <h3 className="text-lg sm:text-xl font-bold text-[#0c3b42] mb-2 sm:mb-4" data-id="element-23">
              MÁS SEGURIDAD PROFESIONAL
            </h3>
            <p className="text-sm sm:text-base text-slate-600 leading-relaxed" data-id="element-24">
              Entrás a cada sesión sabiendo qué observar, qué preguntar, cómo
              adaptar la intervención y cómo transformar la demanda del
              deportista en un plan de trabajo mental claro.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-slate-50 p-5 sm:p-8 rounded-2xl border border-slate-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-25">
            <div className="w-11 h-11 sm:w-14 sm:h-14 bg-[#0c3b42] rounded-xl flex items-center justify-center mb-4 sm:mb-6" data-id="element-26">
              <LayoutList className="w-6 h-6 sm:w-7 sm:h-7 text-[#7fd1c9]" data-id="element-27" />
            </div>
            <h3 className="text-lg sm:text-xl font-bold text-[#0c3b42] mb-2 sm:mb-4" data-id="element-28">
              MÁS ORDEN EN CADA PROCESO
            </h3>
            <p className="text-sm sm:text-base text-slate-600 leading-relaxed" data-id="element-29">
              Dejás de depender de "a ver qué trae hoy" y empezás a trabajar con
              evaluación, planificación, intervención, coordinación con entorno,
              seguimiento y cierre profesional.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-slate-50 p-5 sm:p-8 rounded-2xl border border-slate-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-30">
            <div className="w-11 h-11 sm:w-14 sm:h-14 bg-[#0c3b42] rounded-xl flex items-center justify-center mb-4 sm:mb-6" data-id="element-31">
              <FileText className="w-6 h-6 sm:w-7 sm:h-7 text-[#7fd1c9]" data-id="element-32" />
            </div>
            <h3 className="text-lg sm:text-xl font-bold text-[#0c3b42] mb-2 sm:mb-4" data-id="element-33">
              ESTRUCTURA REAL
            </h3>
            <p className="text-sm sm:text-base text-slate-600 leading-relaxed" data-id="element-34">
              Protocolos, guías, técnicas, plantillas y herramientas listas para
              aplicar en evaluación, sesiones individuales, competencia
              adaptada, discapacidad adquirida y comunicación con cuerpo
              técnico.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}